/* Utilities JS: Universal helper functions */

// Get width of scrollbar, set to custom property
const getScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    return scrollbarWidth;
}

// Smooth scrolling between page elements
const smoothScroll = (target, dest) => {
    target.addEventListener('click', e => {
        e.preventDefault();
        const dest = document.querySelector(`[name='${target.dataset.scrolltarget}']`) || document.querySelector('body');
        dest.scrollIntoView({ 
            behavior: 'smooth' 
        });
        dest.focus();
    });
}

// Detect when an element is being sticky, add class when true
const isStuck = el => {
    const observer = new IntersectionObserver( ([e]) => {
        el.classList.toggle('stuck', e.intersectionRatio < 1);
    }, { threshold: [1] });
    observer.observe(el);
}

// pass in a text element, the parent of that text element and a length
const setExpander = (textEl, parentEl, length) => {
    if ( textEl.innerText.length > length ) {
        textEl.setAttribute('aria-expanded', 'false');
        moreBtn = document.createElement('button');
        moreBtn.classList.add('expand', 'btn');
        moreBtn.innerText = 'Read More';
        parentEl.appendChild(moreBtn);
        moreBtn.onclick = () => {
            if ( textEl.getAttribute('aria-expanded') == 'true') {
                moreBtn.innerText = 'Read More';
                textEl.setAttribute('aria-expanded', 'false');
                textEl.scrollIntoView({behavior: 'smooth'});
            } else {
                moreBtn.innerText = 'Read Less';
                textEl.setAttribute('aria-expanded', 'true');
            }
        };
    }
}
